export default "<p>payment-billing-branch works!</p>\r\n";